import { Component } from '@angular/core';

@Component({
  selector: 'app-upload',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.6622 14.9755H4.80418C4.55725 14.9655 4.31473 14.9068 4.09049 14.8029C3.86626 14.699 3.66471 14.5519 3.49738 14.37C3.33006 14.1882 3.20023 13.9751 3.11535 13.743C3.03046 13.5109 2.99217 13.2643 3.00267 13.0174V10.8812C3.00267 10.7396 3.05894 10.6037 3.15909 10.5036C3.25925 10.4034 3.39508 10.3472 3.53672 10.3472C3.67836 10.3472 3.81419 10.4034 3.91434 10.5036C4.0145 10.6037 4.07076 10.7396 4.07076 10.8812V13.0174C4.05238 13.2288 4.11608 13.4392 4.24866 13.6049C4.38123 13.7707 4.57251 13.879 4.78282 13.9075H13.6622C13.8725 13.879 14.0638 13.7707 14.1964 13.6049C14.3289 13.4392 14.3926 13.2288 14.3742 13.0174V10.8812C14.3742 10.7396 14.4305 10.6037 14.5307 10.5036C14.6308 10.4034 14.7667 10.3472 14.9083 10.3472C15.0499 10.3472 15.1858 10.4034 15.2859 10.5036C15.3861 10.6037 15.4423 10.7396 15.4423 10.8812V13.0174C15.4637 13.5125 15.2886 13.9961 14.9552 14.3628C14.6218 14.7295 14.1571 14.9497 13.6622 14.9755Z"
    fill="#183A25"
  />
  <path
    d="M12.0814 6.43099C12.0113 6.43132 11.9418 6.41763 11.8769 6.39073C11.8121 6.36383 11.7534 6.32426 11.7041 6.27433L9.23321 3.80349L6.76237 6.27433C6.66113 6.36867 6.52723 6.42002 6.38888 6.41758C6.25053 6.41514 6.11852 6.35909 6.02068 6.26125C5.92283 6.1634 5.86678 6.0314 5.86434 5.89304C5.8619 5.75469 5.91326 5.62079 6.00759 5.51955L8.85582 2.67132C8.95596 2.57131 9.09169 2.51514 9.23321 2.51514C9.37473 2.51514 9.51047 2.57131 9.6106 2.67132L12.4588 5.51955C12.5588 5.61969 12.615 5.75542 12.615 5.89694C12.615 6.03847 12.5588 6.1742 12.4588 6.27433C12.4095 6.32426 12.3507 6.36383 12.2859 6.39073C12.2211 6.41763 12.1516 6.43132 12.0814 6.43099Z"
    fill="#183A25"
  />
  <path
    d="M9.23326 11.4154C9.0922 11.4135 8.95743 11.3567 8.85768 11.2569C8.75792 11.1572 8.70106 11.0224 8.69922 10.8813V3.04869C8.69922 2.90705 8.75548 2.77122 8.85564 2.67107C8.95579 2.57091 9.09163 2.51465 9.23326 2.51465C9.3749 2.51465 9.51074 2.57091 9.61089 2.67107C9.71104 2.77122 9.76731 2.90705 9.76731 3.04869V10.8813C9.76546 11.0224 9.7086 11.1572 9.60885 11.2569C9.50909 11.3567 9.37433 11.4135 9.23326 11.4154Z"
    fill="#183A25"
  />
</svg>
`
})
export class UploadComponent {

}
